import Layout from "../../components/layOutWrapper/layOutWrapper";
import TravelAllowanceRequestForm from "../../components/travelAllowanceRequests/travelAllowanceRequestForm";

export default function TravelAllowanceRequestFormView () {
    return (
        <>
            <Layout children={<TravelAllowanceRequestForm/>} sectionTitle="Enviar solicitud de viático"/>
        </>
    )
}